import { createContext, useState, useEffect, useContext } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const decodeToken = (token) => {
        try {
            const payloadBase64 = token.split(".")[1];
            const decodedPayload = JSON.parse(atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/")));

            return {
                token,
                role: decodedPayload.role || "Guest",
                username: decodedPayload.sub,
                exp: decodedPayload.exp,
            };
        } catch (error) {
            console.error("❌ Error decoding token:", error);
            return null;
        }
    };

    const [user, setUser] = useState(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedUser = decodeToken(token);
            return decodedUser && decodedUser.exp * 1000 > Date.now() ? decodedUser : null;
        }
        return null;
    });

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedUser = decodeToken(token);
            if (decodedUser && decodedUser.exp * 1000 > Date.now()) {
                setUser(decodedUser);
                startTokenExpiryCheck(decodedUser.exp);
            } else {
                logout();
            }
        }
    }, []);

    const login = ({ token }) => {
        localStorage.setItem("token", token);
        const decodedUser = decodeToken(token);

        if (decodedUser) {
            console.log("🔹 Updating AuthContext user:", decodedUser);
            setUser(decodedUser);
            startTokenExpiryCheck(decodedUser.exp);
        } else {
            logout();
        }
    };

    const logout = () => {
        console.log("🚀 Logging out...");
        localStorage.removeItem("token");
        setUser(null);
    };

    const startTokenExpiryCheck = (exp) => {
        const timeUntilExpiry = exp * 1000 - Date.now();
        if (timeUntilExpiry > 0) {
            setTimeout(() => {
                console.warn("⏳ Token expired. Logging out...");
                logout();
            }, timeUntilExpiry);
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// ✅ Fix: Export `useAuth`
export const useAuth = () => useContext(AuthContext);
